import {Vector2} from 'three'

import type {MonaCanvasOpeningAnimation} from '../../MonaCanvas'

const START_X = -1.25
const END_X = 0.6
const OFFSET_X = Math.PI
const SINE_AMPLITUDE = 2
const SINE_FREQUENCY = 1.5 * Math.PI
const HORIZONTAL_SPEED = 1
const VERTICAL_OFFSET = 0.3

class MonaDividerOpeningAnimation implements MonaCanvasOpeningAnimation {
  readonly pointerPosition = new Vector2(START_X, Math.sin(START_X * SINE_FREQUENCY + OFFSET_X) * SINE_AMPLITUDE)
  hasReachedEnd = false

  update(delta: number) {
    if (this.hasReachedEnd) return

    this.pointerPosition.x = Math.min(END_X, this.pointerPosition.x + delta * HORIZONTAL_SPEED)
    this.pointerPosition.y =
      VERTICAL_OFFSET + Math.sin(this.pointerPosition.x * SINE_FREQUENCY + OFFSET_X) * SINE_AMPLITUDE
    this.hasReachedEnd = this.pointerPosition.x === END_X
  }
}

export function createMonaDividerOpeningAnimation(): MonaCanvasOpeningAnimation {
  return new MonaDividerOpeningAnimation()
}
